import React from 'react'

function BlogDetailBred() {
  return (
    <div>


      <section className="bredcrumb_section blog_list_page">
        <div className="container">
          <div
            className="section_title text-center"
            data-aos="fade-up"
            data-aos-duration={1500}
          >
            <span className="sub_text">Our Story</span>
            <h2>About Us</h2>
          </div>
        </div>
      </section>

    </div>
  )
}

export default BlogDetailBred